<br />
<div class="container">
  <div class="container-fluid container-shadow" style="overflow-y:auto;" *ngIf="isError">
    <app-error [message]="errorMessage"></app-error>
  </div>
</div>
<span *ngIf="isRequestLoading" class="justify-content-center">
  <app-loading [displayeMessage]="true"></app-loading>
</span>

<div class="container-fluid" *ngIf="requestSummary">
  <div class="border-4 border-bottom" style="height: 40px; background: #EEEEEE 0% 0% no-repeat padding-box; width: 100%;">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center pt-1">
          <span class="font-color-navy welcome-text">Request Details</span>
        </h2>
      </div>
    </div>
  </div>

  <br />
  <div class="container-fluid font-color-navy container-shadow" style="width:100%;">
    <div class="row">
      <div class="col-md-4 control-display-sm">
        <span class="div-title-sm">Title</span>
        <div class="normal-text bold-text" title="Title">
          <input type="text" id="requestTitle" name="requestTitle" [(ngModel)]="requestTitle" (change)="valueChange($event)" [disabled]="!canClose" required />
        </div>

      </div>
      <div id="deadlineDiv" class="col-md-2 control-display-sm" style="margin:0 10px 0 25px;">
        <mat-form-field subscriptSizing="dynamic">
          <mat-label>Deadline:</mat-label>
          <input matInput [matDatepicker]="requestDatepicker" [formControl]="newDate" [min]="minDate"
                 (dateChange)="datePickerEvent('change', $event)" [disabled]="!canEnlargeDeadline">
          <mat-datepicker-toggle matIconSuffix [for]="requestDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #requestDatepicker [disabled]="!canEnlargeDeadline">
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel>Cancel</button>
              <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-1 control-display-sm" style="margin:0 0px 0px 5px;">
        <span class="div-title-sm">Closure Date:</span>
        <div>
          {{requestSummary?.closureDate | date:'mediumDate'}}
        </div>
      </div>
      <div class="col-md-1" style="margin: 15px 0px 0px 0px;">
        <a href="{{requestSummary?.externalLink}}" target="_blank" class="control-display-link" title="View Request in DevOps">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.96" viewBox="0 0 20 19.96">
            <g id="View-in-Azure-icon" transform="translate(0 -2862)">
              <path id="azure_devops_logo_icon_145466" d="M0,11.156,1.872,8.686l7-2.848V3.78l6.142,4.493L2.471,10.707v6.856L0,16.85ZM20,7.448v12.21L15.2,23.74,7.454,21.194V23.74L2.471,17.562l12.549,1.5V8.272Z" transform="translate(0 2858.22)" fill="#ee7d11" />
            </g>
          </svg>
        </a>
      </div>
      <div class="col-md-auto" style="text-align:right;">
        <button id="btnRequestChange" name="btnRequestChange" type="submit" style="margin: 0 10px 0 0;" [ngClass]="isChanged?'btn-new-ui':'btn-new-ui-disabled'" [disabled]="!isChanged" (click)="openConfirmationDialog('save')">
          SAVE CHANGES
        </button>
        <button id="btnRequestClose" type="submit" [ngClass]="canClose?'btn-new-ui':'btn-new-ui-disabled'" [disabled]="!canClose" (click)="openConfirmationDialog('close')">CLOSE REQUEST</button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-1 control-display">
        <span class="div-title">Type</span>
        <div title="Approval" class="normal-text bold-text" *ngIf="requestSummary?.requestType==0">
          <svg id="Approval-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="25.001" viewBox="0 0 20 25.001">
            <path id="ic_bookmark_24px" d="M15.221,10H6.7a1.7,1.7,0,0,0-1.695,1.7L5,18.331l5.962-2.555,5.962,2.555V11.7A1.708,1.708,0,0,0,15.221,10Z" transform="translate(-1 6.67)" fill="#003883" />
            <path id="ic_stars_24px" d="M11.99,2A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2Zm4.24,16L12,15.45,7.77,18l1.12-4.81L5.16,9.96l4.92-.42L12,5l1.92,4.53,4.92.42-3.73,3.23Z" transform="translate(-2 -2)" fill="#003883" />
          </svg>
        </div>
        <div title="Acceptance" class="normal-text bold-text" *ngIf="requestSummary?.requestType==1">
          <svg id="Acceptance-icon" xmlns="http://www.w3.org/2000/svg" width="19.522" height="21.691" viewBox="0 0 19.522 21.691">
            <path id="ic_assignment_turned_in_24px" d="M20.353,3.169H15.819a3.241,3.241,0,0,0-6.117,0H5.169A2.175,2.175,0,0,0,3,5.338V20.522a2.175,2.175,0,0,0,2.169,2.169H20.353a2.175,2.175,0,0,0,2.169-2.169V5.338A2.175,2.175,0,0,0,20.353,3.169Zm-7.592,0a1.085,1.085,0,1,1-1.085,1.085A1.088,1.088,0,0,1,12.761,3.169Z" transform="translate(-3 -1)" fill="#003883" />
            <rect id="Rectangle_2109" data-name="Rectangle 2109" width="10" height="2" transform="translate(4.492 15.69)" fill="#fff" />
            <path id="ic_check_24px" d="M6.588,11.6,4.217,9.234l-.807.8,3.178,3.178L13.41,6.392l-.8-.8Z" transform="translate(1.082 1.062)" fill="#fff" />
          </svg>
        </div>
      </div>
      <div class="col-md-3 control-display">
        <span class="div-title">Project</span>
        <div class="normal-text bold-text">
          {{requestSummary?.project}}
        </div>
      </div>
      <div class="col-md-2 control-display">
        <span class="div-title">Requestor</span>
        <div class="normal-text bold-text">
          {{requestSummary?.requestor}}
        </div>
      </div>
      <div class="col-md-1 control-display">
        <span class="div-title">Id</span>
        <div class="normal-text bold-text">
          {{requestSummary?.requestId}}
        </div>
      </div>
      <div class="col-md-1 control-display">
        <span class="div-title">Status</span>
        <div class="normal-text bold-text">
          {{requestSummary?.status}}
        </div>
      </div>
      <div class="col-md-4 control-display">
        <span class="div-title">Notification</span>
        <span *ngIf="!isRequestLoading">
          <span class="div-expand" (click)="openModal()"><svg height="27px" width="39px" style="float:right;padding-bottom:3px;cursor:pointer;" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 392.619 392.619" xml:space="preserve" fill="#EE7D11"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="149.206,222.201 103.831,267.576 103.846,216.848 73.309,247.384 73.31,319.31 145.235,319.31 175.772,288.773 125.044,288.788 170.418,243.414 170.418,222.201 "></polygon> <polygon points="243.414,170.418 288.788,125.043 288.773,175.771 319.31,145.235 319.309,73.309 247.384,73.309 216.847,103.846 267.575,103.831 222.201,149.205 222.201,170.418 "></polygon> <polygon points="170.418,149.206 125.043,103.831 175.771,103.845 145.235,73.309 73.309,73.309 73.309,145.235 103.845,175.771 103.83,125.044 149.205,170.418 170.418,170.418 "></polygon> <polygon points="288.789,267.576 243.414,222.201 222.201,222.201 222.201,243.414 267.576,288.789 216.848,288.774 247.385,319.31 319.31,319.31 319.31,247.384 288.774,216.848 "></polygon> <path d="M310.724,0.929H81.896C36.738,0.929,0,37.667,0,82.825v226.97c0,45.157,36.738,81.896,81.896,81.896h228.828 c45.157,0,81.896-36.738,81.896-81.896V82.825C392.619,37.667,355.881,0.929,310.724,0.929z M362.619,309.795 c0,28.615-23.28,51.896-51.896,51.896H81.896C53.28,361.69,30,338.41,30,309.795V82.825c0-28.616,23.28-51.896,51.896-51.896 h228.828c28.615,0,51.896,23.28,51.896,51.896V309.795z"></path> <polygon style="fill:#FFFFFF;" points="243.414,222.201 279.645,222.201 279.645,170.418 243.414,170.418 222.201,170.418 222.201,149.205 222.201,112.974 170.418,112.974 170.418,149.206 170.418,170.418 149.205,170.418 112.974,170.418 112.974,222.201 149.206,222.201 170.418,222.201 170.418,243.414 170.418,279.645 222.201,279.645 222.201,243.414 222.201,222.201 "></polygon> </g> </g></svg></span>
          <div [innerHtml]="requestSummary?.comment|trimHtmlcontent"> </div>
          <span *ngIf="requestSummary.comment.length > 200" (click)="openModal()" style="cursor: pointer;">.....(readmore)</span>
        </span>
        <span *ngIf="isRequestLoading">
          <span class="div-expand"><svg height="27px" width="39px" style="float:right;padding-bottom:3px;cursor:not-allowed;" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 392.619 392.619" xml:space="preserve" fill="#7777"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <polygon points="149.206,222.201 103.831,267.576 103.846,216.848 73.309,247.384 73.31,319.31 145.235,319.31 175.772,288.773 125.044,288.788 170.418,243.414 170.418,222.201 "></polygon> <polygon points="243.414,170.418 288.788,125.043 288.773,175.771 319.31,145.235 319.309,73.309 247.384,73.309 216.847,103.846 267.575,103.831 222.201,149.205 222.201,170.418 "></polygon> <polygon points="170.418,149.206 125.043,103.831 175.771,103.845 145.235,73.309 73.309,73.309 73.309,145.235 103.845,175.771 103.83,125.044 149.205,170.418 170.418,170.418 "></polygon> <polygon points="288.789,267.576 243.414,222.201 222.201,222.201 222.201,243.414 267.576,288.789 216.848,288.774 247.385,319.31 319.31,319.31 319.31,247.384 288.774,216.848 "></polygon> <path d="M310.724,0.929H81.896C36.738,0.929,0,37.667,0,82.825v226.97c0,45.157,36.738,81.896,81.896,81.896h228.828 c45.157,0,81.896-36.738,81.896-81.896V82.825C392.619,37.667,355.881,0.929,310.724,0.929z M362.619,309.795 c0,28.615-23.28,51.896-51.896,51.896H81.896C53.28,361.69,30,338.41,30,309.795V82.825c0-28.616,23.28-51.896,51.896-51.896 h228.828c28.615,0,51.896,23.28,51.896,51.896V309.795z"></path> <polygon style="fill:#FFFFFF;" points="243.414,222.201 279.645,222.201 279.645,170.418 243.414,170.418 222.201,170.418 222.201,149.205 222.201,112.974 170.418,112.974 170.418,149.206 170.418,170.418 149.205,170.418 112.974,170.418 112.974,222.201 149.206,222.201 170.418,222.201 170.418,243.414 170.418,279.645 222.201,279.645 222.201,243.414 222.201,222.201 "></polygon> </g> </g></svg></span>
        </span>
        <div *ngIf="isNestedModalOpen" class="nested-modal-overlay" (click)="closeModal()"></div>

        <div *ngIf="isNestedModalOpen" class="nested-modal">
          <mat-dialog-actions align="end">
            <button mat-button (click)="closeModal()"><mat-icon>cancel</mat-icon>Close</button>
          </mat-dialog-actions>
          <h2 class="text-center pt-1" style="background-color: #7777;">
            <span class="font-color-navy welcome-text">Notification</span>
          </h2>
          <div class="normal-text" id="Image_resize" [innerHtml]="requestSummary?.comment|safeHtml"></div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <div class="container-fluid font-color-navy container-shadow" style="width:100%;">
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">Tasks</span>
        </ng-template>
        <app-task-statistics [requestId]="requestId" [canModify]="canClose" [project]="requestSummary?.project"></app-task-statistics>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">Reviewers</span>
        </ng-template>
        <app-request-reviewers [requestId]="requestId" [canModify]="canClose" [project]="requestSummary?.project"></app-request-reviewers>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">Moderators</span>
        </ng-template>
        <app-request-moderators [requestId]="requestId" [canModify]="canClose" [project]="requestSummary?.project"></app-request-moderators>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label">Overview</span>
        </ng-template>
        <app-request-statistics [requestId]="requestId"></app-request-statistics>
      </mat-tab>
    </mat-tab-group>
  </div>
  <br />
</div>
